import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterArticle_template} from "./filterArticle_template";
import {
    filterSingleDate_template
} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingleDate_template";
import {DragAndDropHandler} from "../../utils/DragAndDropHandler";
import {pollQuestion_template} from "./pollQuestion_template";
import {UuidGenerator} from "../../utils/UuidGenerator";
import {
    multipleSelector_template
} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {
    validationsList_template
} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {PollFormatter} from "../../utils/PollFormatter";
import {PollEditMarkupIds, PollMarkup} from "./pollMarkup";
import {PollCommercialSignals} from "../../utils/PollCommercialSignals";
import {InsertDropdownController} from "../../utils/InsertDropdownController";

declare var ko: any;

export class pollPickerEdit_template extends vnTemplate {

    public static readonly MARKUP_IDS: PollEditMarkupIds = {
        sectionLabelInput: "poll-picker-section-label",
        addSectionButton: "poll-picker-add-section",
        addQuestionButton: "poll-picker-add-question",
    };

    protected parent: any;
    public validationsList: validationsList_template;
    protected datePicker: filterSingleDate_template;
    protected brandsFilter: multipleSelector_template;
    protected pollQuestionLightbox: pollQuestion_template;
    protected uuidGenerator: UuidGenerator;
    protected referenceArticle: filterArticle_template;
    protected discussionArticle: filterArticle_template;
    protected insertDropdown: InsertDropdownController;

    protected getTemplateHtml(): string {
        return /* html */ `
            <div class="w-picker-form form-edit form-poll quiz-edit-layout" id="poll-picker-edit" data-bind="css: { 'is-visible': isShown }">
                <div class="picker-form">
                    <div class="form-header w-justify">
                        <input id="poll-picker-id" data-bind="value: id" type="hidden">
                        <div class="w-left"></div>
                        <div class="w-center">
                            <div class="section-title">
                                <h3 class="section-title icon i-poll" data-bind="text: id() != null ? 'Edit Poll' : 'Add Poll'"></h3>
                            </div>
                        </div>
                        <div class="w-right">
                            <button type="button" class="close-btn icon i-close" data-bind="event: { click: onClickCancel }"></button>
                        </div>
                    </div>

                    ${this.validationsList.getHtmlBuild()}

                    <div class="quiz-picker-scroll">
                        ${PollMarkup.sectionHeading('Info')}
                        ${PollMarkup.editInfoPanel({
                            titleInputId: 'poll-picker-title',
                            datePickerContainerId: 'poll-picker-date-picker',
                            datePickerLabelFor: 'pollPickerDate',
                            brandTagsContainerId: 'poll-picker-selected-brands',
                            selectedArticleContainerId: 'poll-picker-selected-source-article',
                            selectedDiscussionArticleContainerId: 'poll-picker-selected-discussion-article',
                            datePickerHtml: this.datePicker.getHtmlBuild(),
                            brandsFilterHtml: this.brandsFilter.getHtmlBuild(),
                            referenceArticleHtml: this.referenceArticle.getHtmlBuild(),
                            discussionArticleHtml: this.discussionArticle.getHtmlBuild(),
                        })}
                        ${PollMarkup.sectionHeading('Content', ';padding-top: 1rem')}
                        <div class="w-poll-body">
                            ${PollMarkup.editSectionsAndToolbar(pollPickerEdit_template.MARKUP_IDS)}
                            ${PollMarkup.questionEditCards()}
                        </div>
                    </div>

                    <div class="form-footer">
                        <button data-bind="event: { click: onClickCancel }" class="btn" type="button">Cancel</button>
                        <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>
                        ${PollMarkup.insertDropdown({
                            toggleLabel: 'Save &amp; Insert',
                            clickHandler: 'onClickSaveAndInsert',
                            titlePrefix: 'Save and Insert',
                        })}
                        ${PollMarkup.displayTitleCheckbox('poll-picker-edit-with-title')}
                    </div>
                </div>
            </div>

            ${PollMarkup.questionLightbox(this.pollQuestionLightbox.getHtmlBuild())}
        `;
    }

    protected initPartial(): void {
        this.validationsList = new validationsList_template("pollPickerEditValidationsList", this.getTemplateViewModel(), this.caller);
        this.validationsList.setWidth("50%");

        this.datePicker = new filterSingleDate_template("pollPickerFilterDate", this.getTemplateViewModel(), this.caller);
        this.datePicker.toggleClearButton(true);
        this.datePicker.setMinutesInterval(1);
        // A poll only closes on a date somebody chose, so the picker drops the current date it starts with.
        this.setDateClosed(null);

        this.brandsFilter = new multipleSelector_template("pollPickerBrandsFilter", this.getTemplateViewModel(), this.caller);
        this.brandsFilter.setLabel("Brands");
        this.brandsFilter.setFilterContainerClass("margin-neg");
        this.brandsFilter.setTagContainerId("poll-picker-selected-brands");
        this.brandsFilter.setTagContainerCaption("");

        this.pollQuestionLightbox = new pollQuestion_template("pollPickerQuestionLightbox", this.getTemplateViewModel(), this);
        this.pollQuestionLightbox.setHideHeaderTitle(true);

        this.uuidGenerator = new UuidGenerator();
        this.referenceArticle = new filterArticle_template("pollPickerFilterArticle", this.getTemplateViewModel(), this.caller);
        this.referenceArticle.setSelectionMode(filterArticle_template.SINGLE_SELECTION_MODE);
        this.referenceArticle.setShowDetails(true);
        this.referenceArticle.setShowSelectedArticlesDetails(true);
        this.referenceArticle.setTagContainerId("poll-picker-selected-source-article");
        this.referenceArticle.setIsLoadingAnimationEnable(true);

        this.discussionArticle = new filterArticle_template("pollPickerDiscussionArticle", this.getTemplateViewModel(), this.caller);
        this.discussionArticle.setSelectionMode(filterArticle_template.SINGLE_SELECTION_MODE);
        this.discussionArticle.setShowDetails(true);
        this.discussionArticle.setShowSelectedArticlesDetails(true);
        this.discussionArticle.setTagContainerId("poll-picker-selected-discussion-article");
        this.discussionArticle.setIsLoadingAnimationEnable(true);

        this.insertDropdown = new InsertDropdownController(this.getTemplateViewModel().isInsertDropdownOpen);
    }

    protected getTemplateName(): string {
        return "pollPickerEdit-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected buildViewModel(): any {
        const self = this;
        const vm: any = {
            isShown: ko.observable(false),
            id: ko.observable(null),
            brandId: ko.observable(null),
            discussionArticleBrandName: ko.observable(""),
            name: ko.observable(""),
            description: ko.observable(""),
            idReferenceArticle: ko.observable(null),
            idReferenceBrand: ko.observable(null),
            dateGeneratedFromArticle: ko.observable(null),
            sections: ko.observableArray([]),
            questions: ko.observableArray([]),
            signalTypes: ko.observableArray([]),
            pollSectionLabel: ko.observable(""),
            isQuestionLightBoxShown: ko.observable(false),
            isGeneratingCommercialSignals: ko.observable(false),
            isWithTitle: ko.observable(false),
            isInsertDropdownOpen: ko.observable(false),
            questionOperationTitle: ko.observable("Add Question"),
            onClickCancel: () => self.hide(),
            onClickSave: () => self.onClickSave(),
            onClickSaveAndInsert: (isDynamicPlacement) => self.onClickSaveAndInsert(isDynamicPlacement),
            onClickToggleInsertDropdown: (data, event) => {
                event.stopPropagation();
                self.insertDropdown.toggle();
            },
            onClickAddPollSection: () => self.onClickAddPollSection(),
            onClickDeletePollSection: (data) => self.onClickDeletePollSection(data),
            onClickEditPollQuestion: (data) => self.onClickEditPollQuestion(data),
            onClickDeletePollQuestion: (data) => self.onClickDeletePollQuestion(data),
            onCloseEditedPollQuestion: (data) => self.onCloseEditedPollQuestion(data),
            onClickAddPollQuestion: () => self.onClickAddPollQuestion(),
            onClickGenerateBasedOnArticle: () => self.parent.generatePollFromArticle(),
            onClickGenerateCommercialSignals: () => self.onClickGenerateCommercialSignals(),
            onClickToggleQuestionCommercial: (data) => self.onClickToggleQuestionCommercial(data),
            onClickToggleAllQuestionsCommercial: () => self.onClickToggleAllQuestionsCommercial(),
            getQuestionCommercialToggleLabel: (question) => self.getQuestionCommercialToggleLabel(question),
            hasCommercialSignals: (question) => self.hasCommercialSignals(question),
            formatCommercialSignal: (choice) => self.formatCommercialSignal(choice),
            getCommercialSignalParts: (choice) => self.getCommercialSignalParts(choice),
            handleDragAndDrop: (element, currentObservableArray, childrenSelector) => {
                self.handleDragAndDrop(element, currentObservableArray, childrenSelector);
            },
        };

        vm.hasReferenceArticle = ko.pureComputed(() => self.hasArticleSelection(vm.pollPickerFilterArticle));
        vm.hasDiscussionArticle = ko.pureComputed(() => self.hasArticleSelection(vm.pollPickerDiscussionArticle));

        vm.canGenerateCommercialSignals = ko.computed(() => PollCommercialSignals.canGenerate(vm.questions()));

        vm.hasAnyCommercialSignals = ko.pureComputed(() => PollCommercialSignals.hasAny(vm.questions(), self.getSignalTypes()));

        vm.commercialToggleLabel = ko.pureComputed(() => PollCommercialSignals.getToggleAllLabel(vm.questions(), self.getSignalTypes()));

        return vm;
    }

    public setParent(parent): this {
        this.parent = parent;
        return this;
    }

    public handleDragAndDrop(element, currentObservableArray, childrenSelector): any {
        DragAndDropHandler.handleDragAndDrop(element, currentObservableArray, childrenSelector);
    }

    /**
     * Building the calendar writes the current date into the field, so the close date is put back the
     * way it was: empty until someone picks one, the poll's own date when it already has one.
     */
    public buildDatePickerCalendar(): void {
        const dateClosed = this.getDateClosed();
        this.datePicker.buildCalendar();
        this.setDateClosed(dateClosed);
    }

    public setPoll(poll): void {
        const currentBrandId = this.parent && this.parent.getIdBrand ? this.parent.getIdBrand() : null;
        const formattedPoll = PollFormatter.formatForEdit(poll, currentBrandId);
        this.clearValidationMessages();
        this.setId(formattedPoll.id);
        this.setName(formattedPoll.name);
        this.setDescription(formattedPoll.description);
        this.setQuestions(formattedPoll.questions);
        this.setSections(formattedPoll.sections);
        this.setDateClosed(formattedPoll.dateClosed);
        this.setReferenceBrandId(formattedPoll.idReferenceBrand);
        this.getTemplateViewModel().idReferenceArticle(formattedPoll.idReferenceArticle);
        this.setDateGeneratedFromArticle(formattedPoll.dateGeneratedFromArticle);
        this.setIsWithTitle(formattedPoll.isWithTitle);
        this.setReferenceArticle(formattedPoll.referenceArticle);
        this.setDiscussionArticle(formattedPoll.discussionArticle);
        this.setAttachedBrands(formattedPoll.brandResults.length > 0 ? formattedPoll.brandResults : (poll.brands || []));
    }

    public getPollForRequest(): any {
        return {
            id: this.getId(),
            name: this.getName(),
            description: this.getDescription(),
            questions: this.getQuestions(),
            dateClosed: this.getDateClosed(),
            brands: this.brandsFilter.getSelectedItems(),
            idReferenceArticle: this.getReferenceArticleId(),
            idReferenceBrand: this.getReferenceBrandId(),
            dateGeneratedFromArticle: this.getTemplateViewModel().dateGeneratedFromArticle(),
            discussionArticle: this.getDiscussionArticleForRequest(),
        };
    }

    protected hasArticleSelection(articleViewModel): boolean {
        if (!articleViewModel) {
            return false;
        }

        const selectedArticles = articleViewModel.articleObjs();
        if (selectedArticles && selectedArticles.length > 0) {
            return true;
        }

        const articleObj = articleViewModel.articleObj();
        if (articleObj && articleObj.id) {
            return true;
        }

        return !!articleViewModel.idArticle();
    }

    /**
     * The picker only ever shows the brand the article belongs to, so it submits that brand alone:
     * the discussion articles of the other brands attached to the poll are left as they are.
     */
    public getDiscussionArticleForRequest(): any {
        const brandId = this.getCurrentBrandId();
        if (!brandId) {
            return null;
        }

        return {idBrand: Number(brandId), idArticle: this.getDiscussionArticleId() || null};
    }

    public setDiscussionArticleOptions(articles): void {
        this.discussionArticle.setOptions(articles || []);
    }

    /**
     * @param discussionArticle {idBrand, idArticle, title} of the article's brand, null when it has none
     */
    public setDiscussionArticle(discussionArticle): void {
        this.discussionArticle.resetArticleContainer();
        this.discussionArticle.setSelectedArticle();

        if (!discussionArticle) {
            return;
        }

        const article = {id: discussionArticle.idArticle, title: discussionArticle.title};
        this.discussionArticle.setArticles(article);
        this.discussionArticle.getTemplateViewModel().idArticle(article.id);
    }

    public getDiscussionArticleId() {
        const articleObj = this.discussionArticle.getArticleObj();
        if (articleObj && articleObj.id) {
            return articleObj.id;
        }

        const selectedArticles = this.discussionArticle.getArticleObjs();
        if (selectedArticles && selectedArticles.length > 0) {
            return selectedArticles[0].id;
        }

        return this.discussionArticle.getTemplateViewModel().idArticle();
    }

    /** The picker lives inside an article, so the brand in context is the article's brand. */
    public getCurrentBrandId() {
        return this.getBrandId() || (this.parent && this.parent.getIdBrand ? this.parent.getIdBrand() : null);
    }

    protected onClickSave(): void {
        this.parent.savePoll(this.getPollForRequest());
    }

    protected onClickSaveAndInsert(isDynamicPlacement): void {
        this.insertDropdown.close();
        this.parent.savePoll(this.getPollForRequest(), true, !!isDynamicPlacement);
    }

    public show(): void {
        this.getTemplateViewModel().isShown(true);
        window.setTimeout(() => this.buildDatePickerCalendar(), 0);
    }

    public hide(): void {
        this.insertDropdown.close();
        this.setIsQuestionLightBoxShown(false);
        this.getTemplateViewModel().isShown(false);
    }

    public setValidationMessages(messages): void {
        this.validationsList.setMessages(messages || []);
    }

    public setSingleValidationMessage(message): void {
        this.validationsList.setSingleMessage(message);
    }

    public clearValidationMessages(): void {
        this.validationsList.clearMessages();
    }

    public showLoading(): void {
        const form = document.getElementById("poll-picker-edit");
        form && form.classList.add("loading");
    }

    public hideLoading(): void {
        const form = document.getElementById("poll-picker-edit");
        form && form.classList.remove("loading");
    }

    public setId(id): void {
        this.getTemplateViewModel().id(id);
    }

    public getId() {
        return this.getTemplateViewModel().id();
    }

    public setBrandId(brandId): void {
        this.getTemplateViewModel().brandId(brandId);
        this.refreshDiscussionArticleBrandName();
    }

    /** Belongs to the placeholder about to be inserted, not to the poll, so it is never part of the save payload. */
    public setIsWithTitle(isWithTitle): void {
        this.getTemplateViewModel().isWithTitle(!!isWithTitle);
    }

    public getIsWithTitle(): boolean {
        return !!this.getTemplateViewModel().isWithTitle();
    }

    public getBrandId() {
        return this.getTemplateViewModel().brandId();
    }

    public setName(name): void {
        this.getTemplateViewModel().name(name);
    }

    public getName() {
        return this.getTemplateViewModel().name();
    }

    public setDescription(description): void {
        this.getTemplateViewModel().description(description || "");
    }

    public getDescription() {
        return this.getTemplateViewModel().description();
    }

    public setDateClosed(dateClosed): void {
        this.datePicker.setDate(dateClosed || null);
    }

    public getDateClosed() {
        return this.getTemplateViewModel().pollPickerFilterDate.singleDatePicker();
    }

    public setQuestions(questions): void {
        this.getTemplateViewModel().questions(this.normalizeQuestions(questions || []));
    }

    public getQuestions() {
        return this.getTemplateViewModel().questions();
    }

    protected normalizeQuestions(questions): Array<any> {
        return PollCommercialSignals.normalizeQuestions(questions, this.getSignalTypes());
    }

    public getSignalTypes() {
        return this.getTemplateViewModel().signalTypes();
    }

    protected hasCommercialSignals(question) {
        return PollCommercialSignals.hasSignals(question, this.getSignalTypes());
    }

    protected getCommercialSignalParts(choice) {
        return PollCommercialSignals.getParts(choice, this.getSignalTypes());
    }

    protected formatCommercialSignal(choice) {
        return PollCommercialSignals.format(choice, this.getSignalTypes());
    }

    protected getQuestionCommercialToggleLabel(question) {
        return PollCommercialSignals.getToggleLabel(question, this.getSignalTypes());
    }

    protected onClickToggleQuestionCommercial(question): void {
        PollCommercialSignals.toggle(question, this.getSignalTypes());
    }

    protected onClickToggleAllQuestionsCommercial(): void {
        PollCommercialSignals.toggleAll(this.getQuestions(), this.getSignalTypes());
    }

    protected onClickGenerateCommercialSignals(): void {
        this.parent.generateCommercialSignals();
    }

    public setIsGeneratingCommercialSignals(isGenerating): void {
        this.getTemplateViewModel().isGeneratingCommercialSignals(isGenerating);
    }

    public getIsGeneratingCommercialSignals() {
        return this.getTemplateViewModel().isGeneratingCommercialSignals();
    }

    public setSections(sections): void {
        const cleanedSections = (sections || []).filter((section) => section.id !== 0);
        this.getTemplateViewModel().sections(cleanedSections);
        this.pollQuestionLightbox.setPollSections(cleanedSections);
    }

    public getSections() {
        return this.getTemplateViewModel().sections();
    }

    protected onClickAddPollSection(): void {
        const section = {
            id: this.uuidGenerator.uuid(),
            position: this.getSections().length + 1,
            name: this.getTemplateViewModel().pollSectionLabel(),
            canDelete: true,
            length: 0,
        };
        this.setSections(this.getSections().concat([section]));
        this.getTemplateViewModel().pollSectionLabel("");
    }

    protected onClickDeletePollSection(section): void {
        this.setSections(this.getSections().filter((existing) => existing.id !== section.id));
    }

    protected onClickAddPollQuestion(): void {
        this.pollQuestionLightbox.reset();
        this.pollQuestionLightbox.asAdd();
        this.pollQuestionLightbox.setPollSections(this.getSections());
        this.getTemplateViewModel().questionOperationTitle("Add Question");
        this.setIsQuestionLightBoxShown(true);
    }

    protected onClickEditPollQuestion(question): void {
        this.pollQuestionLightbox.reset();
        this.pollQuestionLightbox.asEdit();
        this.pollQuestionLightbox.setPollQuestion(ko.toJS(question));
        this.pollQuestionLightbox.setPollSections(this.getSections());
        this.getTemplateViewModel().questionOperationTitle("Update Question");
        this.setIsQuestionLightBoxShown(true);
    }

    protected onClickDeletePollQuestion(question): void {
        this.setQuestions(this.getQuestions().filter((existing) => existing.id !== question.id));
        this.decrementSectionCounts(question);
    }

    protected onCloseEditedPollQuestion(data): void {
        this.cancelEditedQuestionInList(data);
    }

    public addQuestionToList(question): void {
        this.setQuestions(this.getQuestions().concat([question]));
        this.incrementSectionCounts(question);
        this.pollQuestionLightbox.reset();
        this.setIsQuestionLightBoxShown(false);
    }

    public updateEditedQuestionInList(question): void {
        this.setQuestions(this.getQuestions().map((existing) => existing.id === question.id ? question : existing));
        this.pollQuestionLightbox.reset();
        this.setIsQuestionLightBoxShown(false);
    }

    public cancelEditedQuestionInList(_question): void {
        this.pollQuestionLightbox.reset();
        this.setIsQuestionLightBoxShown(false);
    }

    public setIsQuestionLightBoxShown(isShown): void {
        this.getTemplateViewModel().isQuestionLightBoxShown(isShown);
    }

    protected incrementSectionCounts(question): void {
        const sections = this.getSections();
        sections.forEach((section) => {
            if (section.id === question.sectionId) {
                section.length = section.length + 1;
            }
        });
        this.setSections(sections);
    }

    protected decrementSectionCounts(question): void {
        const sections = this.getSections();
        sections.forEach((section) => {
            if (section.id === question.sectionId) {
                section.length = Math.max(section.length - 1, 0);
            }
        });
        this.setSections(sections);
    }

    public setReferences(references): void {
        this.setBrandsReferences(references.brands || []);
        this.setSignalTypes(references.signalTypes || []);
    }

    public setBrandsReferences(brands): void {
        this.brandsFilter.setItems(brands || []);
        this.refreshDiscussionArticleBrandName();
    }

    protected refreshDiscussionArticleBrandName(): void {
        const brandId = Number(this.getCurrentBrandId());
        const brand = (this.brandsFilter.getItems() || []).find((brandReference) => Number(brandReference.id) === brandId);

        this.getTemplateViewModel().discussionArticleBrandName(brand ? (brand.name || brand.shortName || "") : "");
    }

    public setSignalTypes(signalTypes): void {
        this.getTemplateViewModel().signalTypes(signalTypes || []);
        this.pollQuestionLightbox.setSignalTypes(signalTypes || []);
    }

    public setArticleOptions(articles): void {
        this.referenceArticle.setOptions(this.formatReferenceArticlesForDisplay(articles || []));
    }

    public syncSelectedSourceArticle(): void {
        this.getTemplateViewModel().idReferenceArticle(this.getReferenceArticleId());
    }

    public getReferenceArticleId() {
        const articleObj = this.referenceArticle.getArticleObj();
        if (articleObj && articleObj.id) {
            return articleObj.id;
        }

        const selectedArticles = this.referenceArticle.getArticleObjs();
        if (selectedArticles && selectedArticles.length > 0) {
            return selectedArticles[0].id;
        }

        return this.referenceArticle.getTemplateViewModel().idArticle();
    }

    public getReferenceBrandId() {
        return this.getTemplateViewModel().idReferenceBrand() || this.getBrandId();
    }

    public setReferenceBrandId(idReferenceBrand): void {
        this.getTemplateViewModel().idReferenceBrand(idReferenceBrand || this.getBrandId());
    }

    public setReferenceArticle(article): void {
        if (article && article.id) {
            this.referenceArticle.resetArticleContainer();
            this.referenceArticle.setArticles(this.formatReferenceArticleForDisplay(article));
            this.referenceArticle.getTemplateViewModel().idArticle(article.id);
            return;
        }

        this.referenceArticle.resetArticleContainer();
    }

    protected formatReferenceArticlesForDisplay(articles): Array<any> {
        return (articles || []).map((article) => this.formatReferenceArticleForDisplay(article));
    }

    protected formatReferenceArticleForDisplay(article): any {
        if (!article) {
            return article;
        }

        const title = article.title || "";
        const id = article.id || "";
        const brandName = article.brandName || article.brandShortName || article.brand || article.shortName || this.getReferenceBrandName();
        return {
            ...article,
            title: `${title} (${id} - ${brandName})`,
        };
    }

    protected getReferenceBrandName(): string {
        const referenceBrandId = this.getReferenceBrandId();
        const brand = (this.brandsFilter.getItems() || []).find((brandReference) => Number(brandReference.id) === Number(referenceBrandId));
        return brand ? (brand.name || brand.shortName || "") : "";
    }

    public setDateGeneratedFromArticle(dateGeneratedFromArticle): void {
        this.getTemplateViewModel().dateGeneratedFromArticle(dateGeneratedFromArticle || null);
        this.referenceArticle.setDisableField(!!dateGeneratedFromArticle);
    }

    public lockReferenceArticle(dateGeneratedFromArticle): void {
        this.setDateGeneratedFromArticle(dateGeneratedFromArticle || new Date().toISOString().slice(0, 19).replace("T", " "));
    }

    public setGeneratedQuestions(questions): void {
        this.setQuestions((questions || []).map((question: any) => ({
            id: this.uuidGenerator.uuid(),
            type: question.type || (question.selection_type === "multi_select" ? "multi-select" : "single-select"),
            question: question.question,
            choices: (question.choices || question.responses || []).map((choice: any, choiceIndex: number) => {
                const choiceText = typeof choice === "string" ? choice : (choice.choiceText || choice.choiceLabel || "");
                return {
                    uuid: this.uuidGenerator.uuid(),
                    id: choiceIndex + 1,
                    choiceLabel: choiceText,
                    choiceText,
                    votes: 0,
                    commercialSignal: typeof choice === "string" ? "" : (choice.commercialSignal || ""),
                    commercialEntity: typeof choice === "string" ? "" : (choice.commercialEntity || ""),
                    commercialValue: typeof choice === "string" ? "" : (choice.commercialValue || ""),
                };
            }),
            sectionId: 0,
            section: "Unassigned",
            votes: 0,
        })));
    }

    public setAttachedBrands(brandResultsOrIds): void {
        const currentBrandId = this.getCurrentBrandId();
        this.refreshDiscussionArticleBrandName();
        let brandIds: Array<number> = [];

        if (!this.getId() && currentBrandId) {
            brandIds = [Number(currentBrandId)];
        } else if (brandResultsOrIds && brandResultsOrIds.length > 0 && typeof brandResultsOrIds[0] === "object") {
            brandIds = brandResultsOrIds.filter((brandResult) => brandResult.isActive).map((brandResult) => Number(brandResult.idBrand));
        } else {
            brandIds = (brandResultsOrIds || []).map((brandId) => Number(brandId));
        }

        brandIds = Array.from(new Set(brandIds));
        this.brandsFilter.setSeletedItemIds(brandIds, true);
        this.brandsFilter.setTags(brandIds, this.brandsFilter.getItems());
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/pollPickerEdit_template.ts